import { Directive, HostBinding } from '@angular/core';

/**
 * A directive that applies dropdown item styling to any element.
 */
@Directive({
  selector: '[psUiDropdownItem], ps-ui-dropdown-item',
})
export class DropdownItemDirective {
  // All items need this class
  @HostBinding('class.dropdown-item') readonly _defaultClass = true;
}
